import {createTokenAISEO} from "@/utils/aux_functions";
import store from "@/store";
import axios from "axios";

/**
 * @param type (string) => GET, POST. Obligatorio
 * @param url (string) => URL DEL WS. Obligatorio
 * @param data (array) => PARÁMETROS QUE NECESITA EL WS. Obligatorio
 * @param params_token (array) => PARÁMETROS QUE NECESITA EL WS. Obligatorio
 * @param petition (string) => AJAX, AXIOS. Opcional
 * @param content_type (string) Opcional
 * @returns {Promise<*|AxiosResponse<any>>}
 */
export async function aiseoBackendPetition(type, url, data, params_token, petition = 'ajax', content_type = 'application/x-www-form-urlencoded; charset=UTF-8') {
    let token = createTokenAISEO(params_token)

    let main_data = {
        'usuario_logueado': store.getters.getUsername,
        'token': token,
        'debug': process.env.NODE_ENV === 'development' ? 1 : 1,
    }
    let final_data = Object.fromEntries(Object.entries(main_data).concat(Object.entries(data)).sort())

    switch (petition.toLowerCase()) {
        case 'ajax':
            return $.ajax({
                type: type,
                url: process.env.VUE_APP_AISEO_BACKEND_URL + url,
                data: final_data,
                headers: {
                    'content-type': content_type
                }
            });
        case 'axios':
            switch (type.toLowerCase()) {
                case 'post':
                    return axios.post(process.env.VUE_APP_AISEO_BACKEND_URL + url,
                        final_data,
                        {
                            headers: {
                                'content-type': content_type
                            }
                        }
                    )
                case 'get':
                    return axios.get(process.env.VUE_APP_AISEO_BACKEND_URL + url + final_data,
                        {
                            headers: {
                                'content-type': content_type
                            }
                        }
                    )
            }
    }

}
